import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getteacherFeedbackAPi,deleteteacherFeedbackApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// get teacherFeedback
export const getteacherFeedback = createAsyncThunk('getteacherFeedback/teacherFeedback', async () => {
    try {
        const response = await axios.get(`${getteacherFeedbackAPi}?limit=`, { headers });
        return response.data; 
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete teacherFeedback
export const deleteteacherFeedbacks = createAsyncThunk('deleteteacherFeedbacks/teacherFeedback', async (teacherFeedbackid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteteacherFeedbackApi}/${teacherFeedbackid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'teacherFeedbackid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const teacherFeedbackSlice = createSlice({
    name: 'teacherFeedback',
    initialState: {
        teacherFeedbacks: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getteacherFeedbacks
            .addCase(getteacherFeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getteacherFeedback.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.teacherFeedbacks = action.payload;
            })
            .addCase(getteacherFeedback.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete teacherFeedbacks
            .addCase(deleteteacherFeedbacks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteteacherFeedbacks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.teacherFeedbacks.data = state.teacherFeedbacks.data.filter(teacherFeedbacks => teacherFeedbacks.teacherFeedbackid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteteacherFeedbacks.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default teacherFeedbackSlice.reducer;
